import React, { Component } from 'react';
import PropTypes from 'prop-types';
import url from 'url';
import Select from 'react-select';
import _ from 'lodash';
import Switch from 'react-switch';
import { zipCodeUSALength } from '../../../../constants/general';
import { pushHistoryState } from '../../../../helpers/routing';
import { taxTypes } from '../../../../constants/companies';

const participantGroups = {
  workers: {
    id: 'workers',
    ui: 'Workers'
  },
  employers: {
    id: 'employers',
    ui: 'Employers'
  },
  chooseUsers: {
    id: 'chooseUsers',
    ui: 'Choose Users'
  }
};

const workersGroups = {
  onlyOnboarded: {
    id: 'onlyOnboarded',
    ui: 'All Onboarded Workers'
  },
  skillLocation: {
    id: 'skillLocation',
    ui: 'By Skill & Location'
  }
};

export default class GroupMessages extends Component {
  static propTypes = {
    skillsList: PropTypes.array.isRequired,
    workersPredictionsList: PropTypes.array.isRequired,
    searchWorkersAction: PropTypes.func.isRequired,
    clearWorkersPredictionsList: PropTypes.func.isRequired,
    getUserConversations: PropTypes.func.isRequired,
    path: PropTypes.string.isRequired
  };

  userSelect = null;

  initialState = {
    participantsList: [],
    messageText: '',
    sms: false,
    push: true,
    selectedSkillId: 0,
    distanceMiles: '',
    zipCode: '',
    tax_type: taxTypes.W2
  };

  state = {
    ...this.initialState,
    selectedGroup: participantGroups.workers.id,
    selectedWorkersGroup: workersGroups.onlyOnboarded.id
  };

  switchTab = e => {
    const selectedGroup = e.target.id;
    this.setState({ selectedGroup });
  };

  switchWorkersGroup = e => {
    const selectedWorkersGroup = e.target.id;
    this.setState({ selectedWorkersGroup });
  };

  selectSkill = event => this.setState({
    selectedSkillId: parseInt(event.target.value, 10)
  });

  handleChangeDistanceMiles = event => this.setState({
    distanceMiles: event.target.value
  });

  handleChangeZipCode = event => this.setState({
    zipCode: event.target.value
  });

  handleTypingUserName = inputValue => {
    if (inputValue) {
      return this._searchAction(inputValue);
    }
  };

  _searchAction = _.debounce(this.props.searchWorkersAction, 300);

  handleSelectUserName = selectedOption => {
    const { participantsList } = this.state;
    participantsList.push(selectedOption.userData);
    this.setState({ participantsList });
    this.props.clearWorkersPredictionsList();
  };

  deleteParticipant = userId => {
    const updatedParticipants = this.state.participantsList.filter(user => user.id !== userId);
    this.setState({
      participantsList: updatedParticipants
    });
    this.userSelect.focus();
  };

  handleChangeMessageText = e => {
    this.setState({ messageText: e.target.value });
  };

  handleChangeSMS = checked => {
    this.setState({
      sms: checked
    });
  };

  handleChangePush = checked => {
    this.setState({
      push: checked
    });
  };

  handleTaxType = event => this.setState({
    [event.target.name]: event.target.checked ? null : event.target.value
  });

  getPayloadData = () => {
    const { selectedGroup, selectedWorkersGroup, messageText, sms, push, selectedSkillId, distanceMiles, zipCode,
      participantsList, tax_type } = this.state;
    const formData = {
      message: messageText,
      sendSms: sms,
      sendPushNotification: push
    };
    switch (selectedGroup) {
      case participantGroups.workers.id:
        formData.sendToWorkers = true;
        formData.sendToOnboardedOnly = selectedWorkersGroup === workersGroups.onlyOnboarded.id || selectedWorkersGroup === workersGroups.skillLocation.id;
        if (selectedWorkersGroup === workersGroups.skillLocation.id) {
          if (tax_type !== null) {
            formData.tax_type = tax_type;
          }
          if (selectedSkillId) {
            formData.jobSkillId = selectedSkillId;
          }
          const distanceMilesNumber = parseInt(distanceMiles, 10);
          const zipNumber = parseInt(zipCode, 10);
          if (!Number.isNaN(distanceMilesNumber) && !Number.isNaN(zipNumber) && zipCode.length === zipCodeUSALength) {
            formData.zipCode = zipNumber;
            formData.distanceMiles = distanceMilesNumber;
          } else if (distanceMiles || zipCode) {
            return this.props.UIShowAlert('Zip code or quantity of miles are invalid');
          }
        }
        break;
      case participantGroups.employers.id:
        formData.sendToEmployers = true;
        break;
      default: // in case participantGroups.chooseUsers.id
        if (participantsList.length === 0) {
          return this.props.UIShowAlert('You need to choose at least one user');
        }
        formData.userIds = participantsList.map(participantData => participantData.id);
        break;
    }
    return formData;
  };

  sendMessage = e => {
    e.preventDefault();
    if (!this.state.messageText) {
      return;
    }
    const formData = this.getPayloadData();
    if (!formData) {
      return;
    }
    this.props.sendBulkMessageAction(formData).then(data => {
      if (data) {
        this.setState(prevState => ({ ...prevState, ...this.initialState }));
      }
      const { page } = url.parse(window.location.href, true).query;
      const activePage = !parseInt(page, 10) ? 0 : parseInt(page, 10) - 1;
      if (activePage !== 0) {
        pushHistoryState(this.props.path);
      }
      this.props.getUserConversations(0);
    });
  };

  render () {
    const { participantsList, messageText, sms, push, selectedGroup, selectedWorkersGroup, selectedSkillId,
      distanceMiles, zipCode, tax_type } = this.state;
    const { workersPredictionsList, skillsList } = this.props;
    const options = workersPredictionsList.map(user => ({
      value: user.email, // with value equals to user.id (type number) react-select doesn't render options correctly
      label: `${user.first_name} ${user.last_name}, ${user.email}`,
      userData: user
    }));
    const sendingIsDisabled = !messageText || (!sms && !push);
    return (
      <form className='group-messages-wrapper' onSubmit={this.sendMessage}>
        <div className='group-messages-row'>
          <div className='group-messages-label'><strong>Group By:</strong></div>
          <div className='options-wrapper'>
            <div
              className={selectedGroup === participantGroups.workers.id ? 'option active' : 'option'}
              id={participantGroups.workers.id}
              onClick={this.switchTab}
            >{participantGroups.workers.ui}</div>
            <div
              className={selectedGroup === participantGroups.employers.id ? 'option active' : 'option'}
              id={participantGroups.employers.id}
              onClick={this.switchTab}
            >{participantGroups.employers.ui}</div>
            <div
              className={selectedGroup === participantGroups.chooseUsers.id ? 'option active' : 'option'}
              id={participantGroups.chooseUsers.id}
              onClick={this.switchTab}
            >{participantGroups.chooseUsers.ui}</div>
          </div>
        </div>
        { selectedGroup === participantGroups.workers.id && (
          <div className='group-messages-row'>
            <div className='group-messages-label'><strong>Send To:</strong></div>
            <div>
              <div className='options-wrapper'>
                <div
                  className={selectedWorkersGroup === workersGroups.onlyOnboarded.id ? 'option active' : 'option'}
                  id={workersGroups.onlyOnboarded.id}
                  onClick={this.switchWorkersGroup}
                >
                  {workersGroups.onlyOnboarded.ui}
                </div>
                <div
                  className={selectedWorkersGroup === workersGroups.skillLocation.id ? 'option active' : 'option'}
                  id={workersGroups.skillLocation.id}
                  onClick={this.switchWorkersGroup}
                >
                  {workersGroups.skillLocation.ui}
                </div>
              </div>
              { selectedWorkersGroup === workersGroups.skillLocation.id && (
                <React.Fragment>
                  <div className='mt-2'>
                    <label>
                      <input type='checkbox' onChange={this.handleTaxType} value={taxTypes.W2} name='tax_type' checked={!tax_type} />
                      <span>Include 1099M Workers</span>
                    </label>
                  </div>
                  <select
                    className='skills-list-select'
                    value={selectedSkillId}
                    onChange={this.selectSkill}
                  >
                    <option value='0'>All Skills</option>
                    {skillsList.map(skill =>
                      <option value={skill.job_skill_id} key={skill.id}>
                        {skill.skill_label}
                      </option>
                    )}
                  </select>
                  <div className='group-messages-location'>
                    Within
                    <input
                      type='number'
                      min='0'
                      step='1'
                      className='distance-miles-zip-input'
                      id='distanceMiles'
                      name='distanceMiles'
                      placeholder='miles'
                      value={distanceMiles}
                      onChange={this.handleChangeDistanceMiles}
                    />
                    <label htmlFor='distanceMiles' className='distance-miles-zip-label'>miles</label>
                    <label htmlFor='zipCode' className='distance-miles-zip-label'>of</label>
                    <input
                      type='number'
                      id='zipCode'
                      name='zipCode'
                      className='distance-miles-zip-input'
                      placeholder='zip'
                      value={zipCode}
                      onChange={this.handleChangeZipCode}
                    />
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
        { selectedGroup === participantGroups.chooseUsers.id && (
          <div className='group-messages-row'>
            <label htmlFor='list-of-participants' className='group-messages-label'><strong>Send To:</strong></label>
            <div id='list-of-participants' className='participants-list'>
              { participantsList.length > 0 && participantsList.map(user => (
                <div key={user.id} className='participant-item'>
                  <div className='participant-name'>{`${user.first_name} ${user.last_name}`}</div>
                  <div role='button' className='delete-button' onClick={() => this.deleteParticipant(user.id)}>x</div>
                </div>
              ))}
              <Select
                ref={element => { this.userSelect = element; }}
                className='search-user'
                autoFocus
                onChange={this.handleSelectUserName}
                onInputChange={this.handleTypingUserName}
                options={options}
                placeholder=''
                onBlur={this.props.clearWorkersPredictionsList}
              />
            </div>
          </div>
        )}
        <div className='group-messages-row'>
          <label htmlFor='group-message-input' className='group-messages-label'><strong>Message:</strong></label>
          <textarea
            className='input input-textarea'
            id='group-message-input'
            rows='5'
            placeholder='Write message...'
            value={messageText}
            onChange={this.handleChangeMessageText}
          />
        </div>
        <div className='group-messages-row'>
          <div className='group-messages-label'><strong>Send via:</strong></div>
          <div className='notif-switchers'>
            <label className='switcher-wrapper'>
              <Switch
                onChange={this.handleChangeSMS}
                checked={sms}
                onColor='#44cbbd'
                uncheckedIcon={false}
                checkedIcon={false}
                width={35}
                height={19}
              />
              <span>SMS</span>
            </label>
            <label className='switcher-wrapper'>
              <Switch
                onChange={this.handleChangePush}
                checked={push}
                onColor='#44cbbd'
                uncheckedIcon={false}
                checkedIcon={false}
                width={35}
                height={19}
              />
              <span>In App</span>
            </label>
          </div>
          <button disabled={sendingIsDisabled} type='submit' className='button button-primary ml-sm-5'>
            Send Message
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/messages/groupMessages/GroupMessages.js